
import { defineComponent, onBeforeMount, reactive } from 'vue'
import { useRoute } from 'vue-router'

import PageState from '@/modules/OktellModule/components/PageState/index.vue'
import OkInvoiceHeader from '@/modules/OktellModule/components/OkInvoiceHeader/index.vue'
import OkInvoiceContent from '@/modules/OktellModule/components/OkInvoiceContent/index.vue'
import OkWaitList from '@/modules/OktellModule/components/OkWaitList/index.vue'

import { InvoiceT } from '@/core/types/orders.types'

import { orders } from '@/core/realisations/orders.realisation'

import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    components: {
        PageState,
        OkInvoiceHeader,
        OkInvoiceContent,
        OkWaitList,
    },
    setup() {
        const notifications = useNotifications()

        const route = useRoute()
        const invoice_id = Number(route.params.invoice_id as string)

        const state = reactive({
            is_loading: false,
            is_failed: false,
            invoice: null as InvoiceT | null,
        })

        const statuses_state = reactive({
            is_loading: false,
            is_failed: false,
            list: [] as any[],
            client_sla_date: null as string | null,
        })

        const problems_state = reactive({
            is_loading: false,
            is_failed: false,
            list: [] as string[],
        })

        const loadInvoiceStatuses = async () => {
            if (!state.invoice) return

            try {
                statuses_state.is_loading = true

                const response = await orders.getInvoiceStatuses(state.invoice.invoice_number)
                statuses_state.list = response.data

                if (response.data.length) {
                    statuses_state.client_sla_date = response.data[0].client_sla_date
                }

                statuses_state.is_failed = false
            } catch (error) {
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При получении статусов произошла ошибка',
                })
                statuses_state.is_failed = true
            } finally {
                statuses_state.is_loading = false
            }
        }

        const loadInvoiceProblems = async () => {
            if (!state.invoice) return

            try {
                problems_state.is_loading = true

                const response = await orders.getInvoiceProblems(state.invoice.id)
                problems_state.list = response.data.problems

                problems_state.is_failed = false
            } catch (error) {
                console.error(error)
                problems_state.is_failed = true
                notifications.notifyError({ error, title: 'При загрузке проблем произошла ошибка' })
            } finally {
                problems_state.is_loading = false
            }
        }

        const loadInvoice = async () => {
            try {
                state.is_loading = true

                const response = await orders.getInvoice(invoice_id)
                state.invoice = response.data

                loadInvoiceStatuses()
                loadInvoiceProblems()

                state.is_failed = false
            } catch (error) {
                state.is_failed = true
                console.error(error)
                notifications.notifyError({
                    error,
                    title: 'При загрузке данных накладной произошла ошибка',
                })
            } finally {
                state.is_loading = false
            }
        }

        onBeforeMount(loadInvoice)

        return {
            state,
            statuses_state,
            problems_state,
            loadInvoice,
            loadInvoiceStatuses,
            loadInvoiceProblems,
        }
    },
})
